import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
import { environment } from '../../../../environments/environment';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../services/seo.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-outage-error',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './outage-error.component.html',
  styleUrl: './outage-error.component.scss',
})
export class OutageErrorComponent implements OnInit {
  env = environment;
  pageLabels: any;
  isBrowser: boolean = false;
  pageReady: boolean = false;
  pageData = {
    seo: {
      description:
        'Manage your natural gas account online with our online account services. Log in today to update your rate plan, make an immediate payment, and more.',
      keywords:
        'Gas South, Southern Gas, natural gas Atlanta, natural gas Georgia, natural gas rates, natural gas plans, natural gas service, natural gas providers Atlanta, natural gas providers Georgia',
      robotsNoIndex: true,
      title: 'Gas South Online Account Services',
      builderRefName: 'Default',
    },
    mainHeader: 'Sorry, Site Temporarily Unavailable',
    subHeader:
      "Some of our services are down due to an unexpected outage. <br> We're unaware of the issue and working on it urgently.",
    needHelpText: 'Need help? Please Call <a href="tel:8774724932">877-472-4932</a>',
    customerCareTitle: 'Customer Care Hours',
    customerCareHours: 'Monday - Friday: 8 am - 7 pm EST<br>Saturday: 8 am - 5 pm EST',
    returnHomeText: 'To return to home page click below',
    gsLogo: '/assets/images/GS_Logo_large.svg',
    imageAltText: 'Gas South Logo',
    ctaLink: {
      ariaLabel: 'Go to gassouth.com Home page',
      builderRefName: 'Website - Home',
      linkText: 'Home',
      url: 'https://www.gassouth.com/home',
    },
  };

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly utils: UtilService,
    private readonly cms: CmsService,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.cms.getContent('oas-outage', 'Outage').subscribe({
      next: (data: any) => {
        if (!this.utils.isNullOrUndefined(data)) {
          this.pageLabels = this.cms.flattenBuilderReferencesPreservingKeys(data);
          this.seoS.setSeoTags(data.seo);
          this.checkPageLabels();
        }
      },
      error: (err) => {
        this.utils.consoleGroup('Error in getContent for Outage page', err);
        this.pageLabels = this.pageData;
        this.seoS.setSeoTags(this.pageData.seo);
        this.pageReady = true;
      },
      complete: () => {
        this.utils.hideSpinner();
      },
    });

    // check fall back data
    this.checkPageLabels();
  }

  checkPageLabels(): void {
    if (!this.utils.isNullOrUndefined(this.pageLabels)) {
      this.pageReady = true;
    }
  }
}
